$(document).ready(function(){
  var courts = ['TRF1',
                'TRF2',
                'TRF3',
                'TRF4',
                'TRF5'
  ];
  var list = document.getElementById('list_process_type');
  $('#select_court').change(function(){
    if (courts.includes(this.value)){
      list.classList.remove('d-none');
    } else {
      list.classList.add('d-none');
  }
  })

  $('[data-toggle="popover"]').popover()

  function checkWidth() {
    var windowSize = $(window).width();

    if (windowSize < 414) {
      document.getElementById('about_item_menu').attributes['data-toggle'].value = 'dropdown'
      document.getElementById('calculator_item_menu').attributes['data-toggle'].value = 'dropdown'
    }
    else {
      document.getElementById('about_item_menu').attributes['data-toggle'].value = 'dropdown disabled'
      document.getElementById('calculator_item_menu').attributes['data-toggle'].value = 'dropdown disabled'
    }
  }
checkWidth();
})
